import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const bankAccountListService = (params: Types.BankAccountListRequest) =>
  RestAPIClient.call<Types.BankAccountListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{employeeId}", params.employeeId.toString()),
    config: {
      requireAuthentication: true,
      params: omit(params, ["employeeId"]),
    },
  });

export const bankAccountDetailService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: string;
}) =>
  RestAPIClient.call<Types.BankAccountDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const bankAccountCreateService = (
  params: Types.BankAccountCreateRequest
) =>
  RestAPIClient.call<Types.BankAccountDetail>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{employeeId}", params.employeeId.toString()),
    config: {
      requireAuthentication: true,
    },
    data: omit(params, ["employeeId"]),
  });

export const bankAccountUpdateService = (
  params: Types.BankAccountUpdateRequest
) =>
  RestAPIClient.call<Types.BankAccountDetail>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, ["employeeId", "id"]),
  });
